import carousel from '@/js/utils/carousel';
const blockCarousel = () => {
    carousel();
};

export default blockCarousel;
